import { cronHttp } from "api/cronHttp";
import { http } from "api/http";

const getECampaignList = ({ queryKey }: any) => {
  return http.get("/compliance/eCampaign", { params: { ...queryKey[1] } });
};

const getClientECampaignList = ({ queryKey }: any) => {
  return http.get(`/compliance/client-eCampaign/${queryKey[1]}`, { params: queryKey[2] });
};

const getClientAutoStatus = ({ queryKey }: any) => {
  return http.get(`/compliance/clientAutoStatus/${queryKey[1]}`);
};

const getComplianceReports = ({ queryKey }: any) => {
  return http.get(`/compliance/reports`, { params: { ...queryKey[1] } });
};

const getComplianceNewUpdates = ({ queryKey }: any) => {
  return http.get(`/compliance/new-updates`, { params: { ...queryKey[1] } });
};

const getActivityLogData = ({ queryKey }: any) => {
  return http.get(`/compliance/activity/${queryKey[1]}`, { params: { ...queryKey[2] } });
};

const exportECampaign = (data: any) => {
  return cronHttp.post("/compliance/export-e-campaign", data);
};

const exportClientECampaignList = (data: any) => {
  return cronHttp.post("/compliance/export-clientEcampaign", data);
};

const exportIncomeTaxReports = (data: any) => {
  return cronHttp.post(`/compliance/export-reports`, data);
};

const getECampaignListTypes = () => {
  return http.get("/compliance/eCampaign-types");
};


export {
  getECampaignList,
  getClientECampaignList,
  getClientAutoStatus,
  getComplianceReports,
  getComplianceNewUpdates,
  getActivityLogData,
  exportECampaign,
  exportClientECampaignList,
  exportIncomeTaxReports,
  getECampaignListTypes
}